import { BookingState, UtmParmeters } from "./types";
import { PromotionCodeDTO } from "api/promo.api";
import { EncounterDto } from "@/api/entities/encounters";
import encountersApi from "@/api/encounters.api";
import { BookingRoutePaths } from "@/utils/constants";

import { defineStore } from "pinia";

export const useBookingStore = defineStore("booking", {
  state: (): BookingState => ({
    encounterId: undefined,
    sex: undefined,
    dob: undefined,
    center: undefined,
    offlineBookings: {},
    onlineBookings: {},
    availableCenters: [],
    memberDiscount: undefined,
    package: undefined,
    packages: undefined,
    promoCode: undefined,
    validEntry: false,
    bookingType: undefined,
    availableDiscounts: [] as PromotionCodeDTO[],
    utmParams: undefined,
    cacAnswers: {
      cacSymptoms: "",
      cacStent: "",
      cacPacemaker: "",
      coronaryHistory: "",
      previousCacScoreThreeYears: "",
      gatedCacStent: "",
      previousCacScoreOver400: "",
      heartMovementRisk: "",
      aiCalciumScoreLimitations: "",
      isRejected: false
    },
    validEntryAppointmentActions: false,
    validAssociateEntry: false,
    finalPrice: "0",
    additionalBookingInformation: undefined,
    currentAppointment: undefined,
    selectedAddons: [],
    eventCenterId: undefined,
    lastUnavailableCenterId: undefined,
    isDeferred: false,
    deferredEncounter: undefined,
    isChangeLocation: false
  }),
  persist: {
    storage: sessionStorage
  },
  actions: {
    setValidPath(bookingType: string) {
      this.validEntry = true;
      this.bookingType = bookingType;
    },
    setValidEntry(validEntry: boolean) {
      this.validEntry = validEntry;
    },
    setValidAssociateEntry(validEntry: boolean) {
      this.validAssociateEntry = validEntry;
    },
    setUTMParameters(utmParams: UtmParmeters) {
      this.utmParams = utmParams;
    },
    setValidEntryAppointmentActions(valid: boolean) {
      this.validEntryAppointmentActions = valid;
    },
    setValidEntryPaymentAuthActions(valid: boolean) {
      this.validEntryAppointmentActions = valid;
    },
    async initializeDeferredBooking(encounter: EncounterDto) {
      this.setValidPath(BookingRoutePaths.BookScan);
      this.isDeferred = true;
      this.deferredEncounter = encounter;
      this.encounterId = encounter.id;
      this.selectedAddons = encounter.addons;

      const packages = await encountersApi.getPackages();
      this.packages = packages;
      this.package = packages.find(p => p.id === encounter.packageId);
    },
    /**
     * Initialize the booking flow for a "Change Location" action on an existing
     * encounter. Reuses the same path as a deferred booking (skips select-plan
     * and the payment step) and additionally flags the submit step to call the
     * change-location endpoint, which cancels the existing scan(s) and books
     * new ones at the chosen center in a single transaction.
     */
    async initializeChangeLocationBooking(encounter: EncounterDto) {
      await this.initializeDeferredBooking(encounter);
      this.isChangeLocation = true;
    }
  }
});
